import { required } from 'vuelidate/lib/validators'
import DatePeriodPicker from '@/components/common/dateperiodpicker/DatePeriodPicker.vue'
import ClientPicker from '@/components/client/picker/ClientPicker.vue';

const defaultEl = {
  id: null,
  pdf_template: null,
  order: 1,
  material_group: null,
  date_period_id: null,
  info: {
    dateandloc: '',
    number: '',
    contractdate: '',
    contractnumber: '',
    datefrom: '',
    orderdate: '',
    ordernumber: ''
  },
  template_overwrites: []
};

export default {
  name: 'DrnTemplatesEdit',
  data () {
    return {
      editEl: defaultEl,
      loading: false
    }
  },
  components: {
    ClientPicker,
    DatePeriodPicker
  },
  validations: {
    editEl: {
      pdf_template: { required },
      material_group: { required },
      date_period_id: { required }
    }
  },
  computed: {
    materialGroupId () {
      if (this.editEl && this.editEl.material_group) {
        return this.$store.getters.getParamFromConfigByFilter('material_groups', 'code', this.editEl.material_group, 'id');
      }
      return null;
    },
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-settings');
    },
    infoParams () {
      return Object.keys(defaultEl.info);
    },
    pdfTemplateOptions () {
      return this.$store.getters.getConfigOptions('pdf_templates', this.$i18n.locale);
    },
    materialGroupOptions () {
      return this.$store.getters.getConfigOptions('material_groups', this.$i18n.locale, 'disabled', 0);
    },
    getTitle () {
      if (this.editEl.id) {
        return this.$t('menu.config.drn-templates.edit');
      }
      return this.$t('menu.config.drn-templates.new');
    }
  },
  methods: {
    show (elData) {
      if (elData) {
        this.editEl = this.BasicHelper.cloneObject(elData);
        this.editEl.info = this.editEl.info.lv;
      } else {
        this.editEl = this.BasicHelper.cloneObject(defaultEl);
      }
      this.editEl.pdf_template = this.$store.getters.getParamFromConfig('pdf_templates', this.editEl.pdf_template_id, 'code');
      this.editEl.material_group = this.$store.getters.getParamFromConfig('material_groups', this.editEl.material_group_id, 'code');
      this.$v.$reset();
      this.$refs['modal-window'].show();
    },
    save () {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.loading) {
        this.loading = true;
        const reqData = { };
        for (const key of Object.keys(defaultEl)) {
          reqData[key] = this.editEl[key];
        }
        const templateOverwrites = [];
        reqData.template_overwrites.forEach(el => {
          templateOverwrites.push({ id: el.id, deleted: (el.deleted ? 1 : 0), client_id: el.client_id, contract_id: el.contract_id });
        });
        reqData.template_overwrites = templateOverwrites;
        reqData.info = { lv: reqData.info };
        const self = this;
        this.ApiRequest.request('drn-templates/edit', this.ApiRequest.REQUEST_POST, { item: reqData }, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          } else {
            self.$emit('saved', response.data);
            self.close();
          }
          self.loading = false;
        });
      }
    },
    close () {
      this.$refs['modal-window'].hide();
    },
    deleteContractOverwrite (idx) {
      if (this.editEl.template_overwrites[idx].id) {
        this.editEl.template_overwrites[idx].deleted = true;
      } else {
        this.editEl.template_overwrites.splice(idx, 1);
      }
      this.$forceUpdate();
    },
    addContractOverwrite () {
      this.editEl.template_overwrites.push({ id: null, client_id: null, contract_id: null, client: null, contract: null });
    },
    getClientInfo (client, key) {
      if (client) {
        this.editEl.template_overwrites[key].client = client;
        this.editEl.template_overwrites[key].client_id = client.id;
        this.editEl.template_overwrites[key].loading = true;
        const self = this;
        this.ApiRequest.request('client/single/' + client.api_id + '/contracts', this.ApiRequest.REQUEST_GET, [], function (response) {
          if (response.data) {
            self.editEl.template_overwrites[key].client.contracts = response.data;
            const contract = response.data.find(el => el.material_group_id == self.materialGroupId);
            if (contract) {
              self.editEl.template_overwrites[key].client.contract_id = contract.id;
              self.editEl.template_overwrites[key].client.contract = contract;
            } else {
              self.editEl.template_overwrites[key].client.contract_id = null;
              self.editEl.template_overwrites[key].client.contract = null;
            }
            self.editEl.template_overwrites[key].loading = false;
            self.$forceUpdate();
          }
        });
      } else {
        this.editEl.template_overwrites[key].client = null;
        this.editEl.template_overwrites[key].client_id = null;
        this.editEl.template_overwrites[key].contract_id = null;
        this.editEl.template_overwrites[key].contract = null;
      }
    }
  }
}
